import { Link } from "react-router-dom";

export default function Partner() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="px-4 py-4 flex justify-center">
        <Link to="/" className="opacity-70 hover:opacity-100 transition-opacity">
          <img src="/ll-mark-256.png" alt="LegacyLens AI" className="h-24" />
        </Link>
      </div>

      <main className="mx-auto max-w-3xl px-6 py-12 md:py-20 text-foreground">
        <header className="mb-12 border-b border-border pb-8">
          <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight leading-tight mb-5">
            For institutions that steward family memory.
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            LegacyLens partners with ancestry platforms, genealogy services, funeral homes, and cemeteries to make capture and preservation a meaningful addition to what they already do.
          </p>
        </header>

        <section className="mb-16">
          <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight mb-6">
            Why partner with LegacyLens
          </h2>
          <div className="space-y-5 text-lg leading-relaxed">
            <p>
              The institutions our families trust most with their memory — ancestry platforms, genealogy services, funeral homes, cemeteries — already do the meaningful work of helping people honor and remember. LegacyLens extends that work into something interactive, durable, and consent-first.
            </p>
            <p>What partners get:</p>
          </div>
          <ul className="mt-5 space-y-3 text-lg leading-relaxed list-disc pl-6">
            <li>
              A new offering for clients and members: capture-while-alive as a service alongside what you already provide.
            </li>
            <li>
              A meaningful revenue share when families commission a digital legacy through your channel.
            </li>
            <li>
              The full{" "}
              <Link
                to="/digital-legacy-directive"
                className="font-medium underline-offset-4 hover:underline text-foreground"
              >
                Digital Legacy Directive
              </Link>
              {" "}— meaning every captured tribute is governed by ten principles that protect subjects, preserve dignity, and earn trust.
            </li>
            <li>
              Infrastructure designed to last beyond all of us. Two-layer write-once-read-many storage. Consent-first by design.
            </li>
          </ul>
        </section>

        <section className="mb-16">
          <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight mb-6">
            Get in touch
          </h2>
          <div className="space-y-5 text-lg leading-relaxed">
            <p>
              We're starting with a small number of founding partners. If you'd like to explore what LegacyLens could look like inside your organization, write to us.
            </p>
            <p>
              <a
                href="mailto:info@legacylensai.com"
                className="font-medium underline-offset-4 hover:underline"
              >
                info@legacylensai.com
              </a>
            </p>
          </div>
        </section>

        <div className="mt-16 pt-8 border-t border-border">
          <Link
            to="/"
            className="text-base text-muted-foreground hover:text-foreground transition-colors"
          >
            ← Back to home
          </Link>
        </div>
      </main>
    </div>
  );
}
